import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=0ca6a5a4&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=0ca6a5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6a5a4",
  null
  
)

export default component.exports